import { render, staticRenderFns } from "./SystemIntegration.vue?vue&type=template&id=a985f722&scoped=true&"
import script from "./SystemIntegration.vue?vue&type=script&lang=js&"
export * from "./SystemIntegration.vue?vue&type=script&lang=js&"
import style0 from "./SystemIntegration.vue?vue&type=style&index=0&id=a985f722&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a985f722",
  null
  
)

export default component.exports